import React from "react";
import { useNavigate } from "react-router-dom";
import useGetSmartScanSelfieCaptureProgress from "../CustomHooks/useGetSmartScanSelfieCaptureProgress";

const SmartScanDisclaimerPage = () => {
  const smartScanState = useGetSmartScanSelfieCaptureProgress();
  const navigate = useNavigate();

  function onIAgreeBtnClicked() {
    if (smartScanState && smartScanState.patientId > 0) {
      navigate("/smart-scan-photo-options", {
        state: {
          patientId: smartScanState?.patientId
        }
      });
    }
  }

  function goToPreviousPage() {
    navigate("/smart-scan-visit", {
      state: {
        ...smartScanState
      }
    });
  }

  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-sm-12">
            <div className="gth-main-header mb-3">
              <div className="heading-wrapper back-to-wrapper position-relative">
                <h1 className="title">Smart Scan Disclaimer </h1>
              </div>
            </div>
            <div className="bg-white border-radius-xlg px-4 px-md-5 py-4">
              <div className="smart-scan-fixed-button-bottom">
                <div className="border border-transparent disclamer-text pt-2 pt-md-4">
                  <p>
                    SCREENING, AND A DISCUSSION BETWEEN YOU AND THE DENTIST OF
                    ANY CHANGES YOU HAVE NOTICED OR QUESTIONS THAT YOU HAVE.
                  </p>
                  <p>
                    THE FOLLOWING DESCRIBES, BUT IS NOT LIMITED TO, SOME OF THE
                    TYPES OF ORAL DISEASE INDICATORS NOT VISIBLE TO THE EYE:
                    BONE LOSS, STATUS OF BONE CREST, POCKET DEPTHS, SUBGINGIVAL
                    CALCULUS, STATUS OF THE PERIODONTAL LIGAMENT, INCIPIENT
                    DECAY, DECAY BETWEEN TEETH, SMALL ENAMEL FRACTURES,
                    ABNORMALITIES ASSOCIATED WITH THE ROOTS AND NERVES,
                    ABSCESSES, ROOT FRACTURES, FULLY IMPACTED TEETH, CYSTS AND
                    TUMORS WITHIN THE JAWBONE, TEMPORO MANDIBULAR JOINT
                    PROBLEMS, MUSCULO SKELETAL ABNORMALITIES, ABNORMALITIES
                    UNDER THE TONGUE, SMALL SOFT TISSUE ABNORMALITIES IN THE
                    LIPS AND CHEEKS THAT REQUIRE PALPATION FOR DISCOVERY.
                  </p>
                  <small
                    className="text-muted my-3 my-md-4"
                    style={{ fontSize: ".875em" }}
                  >
                    <em>
                      BY AGREEING TO RECEIVE THE PHOTO ASSESSMENT FROM
                      DENTAL.COM, I UNDERSTAND...
                    </em>
                  </small>
                </div>
                <div className="btn-div">
                  <button
                    onClick={goToPreviousPage}
                    className="btn btn-outline btn-rounded btn-lg me-2 px-4 px-md-5 mt-3 mt-md-0 w-100 w-md-auto"
                  >
                    Back
                  </button>
                  <button
                    onClick={onIAgreeBtnClicked}
                    disabled={!smartScanState?.patientId}
                    className="btn btn-secondary btn-rounded btn-lg px-4 px-md-5 mt-3 mt-md-0 w-100 w-md-auto"
                  >
                    I Agree
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SmartScanDisclaimerPage;
